import axiosInstance from "../src/Api";
const baseURL = "https://public-api.wordpress.com/rest/v1.1/sites/107403796/";

let APIService = {
    get: async endpoint => {
      var url = baseURL + endpoint;
      return axiosInstance.get(url);
    },
}
export { APIService };